import {
    argumentIssues,
    initialArguments,
} from './manifestArgumentSchema'

const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value, key)

const properties = schema => (
    schema
    && schema.properties
    && !Array.isArray(schema.properties)
    && typeof schema.properties === 'object'
        ? schema.properties
        : {}
)

const propertyType = schema => {
    const declaredTypes = Array.isArray(schema.type) ? schema.type : [schema.type]
    const type = declaredTypes.find(value => value && value !== 'null') || 'string'

    if (type === 'array' && schema.items && schema.items.type === 'string') {
        return 'string_list'
    }
    if (['string', 'integer', 'number', 'boolean', 'object'].includes(type)) {
        return type
    }

    return 'object'
}

const humanize = key => {
    const words = key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/[_-]/g, ' ')
    return words.charAt(0).toUpperCase() + words.slice(1)
}

export const configurationArgumentSchema = (schema = {}) => {
    const required = new Set(Array.isArray(schema.required) ? schema.required : [])

    return {
        allowUnknownArguments: schema.additionalProperties !== false,
        arguments: Object.entries(properties(schema)).map(([name, property]) => {
            const hasConst = hasOwn(property, 'const')
            const hasDefault = hasOwn(property, 'default') || hasConst

            return {
                name,
                title: property.title || humanize(name),
                description: property.description || '',
                type: propertyType(property),
                required: required.has(name),
                nullable: Array.isArray(property.type) && property.type.includes('null'),
                allowedValues: hasConst
                    ? [property.const]
                    : Array.isArray(property.enum) ? property.enum : [],
                hasDefaultValue: hasDefault,
                defaultValue: hasOwn(property, 'default') ? property.default : property.const,
            }
        }),
    }
}

export const initialConfiguration = schema => initialArguments(
    configurationArgumentSchema(schema)
)

export const configurationIssues = (schema, value = {}) => argumentIssues(
    configurationArgumentSchema(schema),
    value
)

